export const cityName = "Сарненська"
export const cityCouncil = "міська рада"
export const altCityName = "Логотип Сарненської міської ради"

export const territory_title = "Сарненська міська рада"
export const territory_title_instrumental = "Сарненської міської територіальної громади"

export const website_name = "Портал місцевих податків Сарненської громади"
export const website_url = "https://sarny.skydatagroup.com/"
export const website_url_p4v = "https://p4v.sarny.skydatagroup.com/"
export const telegram_name ="Місцеві податки Сарненської ТГ"
export const telegram_url ="https://t.me/Sarny_taxes_bot"
export const phone_number_GU_DPS = "(0362) 643247"
export const alt_qr_code = "Qr-code Сарни"
export const GU_DPS_region = "Рівненській області"